import { OrderTypeEnums } from '@models/response/order';
import {
  DeliveryState,
  DeliveryType,
  DiscountCodeType,
  OrderState,
  PaymentMethod,
  TransactionStatus,
  TransactionType,
} from '../../models/ropolo';

const messages = {
  INVALID_PHONE_NUMBER: 'شماره تلفن اشتباه است',
  API_ENDPOINT_NOT_FOUND_ERR: 'API_ENDPOINT_NOT_FOUND_ERR',
  PHONE_ALREADY_EXISTS_ERR: 'شماره وجود دارد',
  PHONE_NOT_FOUND_ERR: 'شماره وجود ندارد',
  USER_NOT_FOUND_ERR: 'کاربری با این شماره تلفن ثبت نام نکرده است.',
  USER_HAS_NOT_ACCESS: 'کاربر دسترسی ندارد',
  INCORRECT_OTP_ERR: 'کد وارد شده صحیح نیست',
  JWT_DECODE_ERR: 'JWT_DECODE_ERR',
  OTP_SENDED: 'کد ارسال شد',
  OTP_VERIFIED: 'OTP_VERIFIED',
  OTP_NOT_VERIFIED: 'رمز یکبار مصرف اشتباه وارد شده است.',
  ACCESS_DENIED_ERR: 'ACCESS_DENIED_ERR',
  FORBIDDEN_ERR: 'FORBIDDEN_ERR',
  AUTH_HEADER_MISSING_ERR: 'AUTH_HEADER_MISSING_ERR',
  AUTH_TOKEN_MISSING_ERR: 'AUTH_TOKEN_MISSING_ERR',
  ADDRESS_NOT_FOUND_ERR: 'آدرس یافت نشد',
  ORDER_NOT_FOUND_ERR: 'سفارش پیدا نشد',
  DUPLICATE_ORDER_STATE: 'DUPLICATE_ORDER_STATE',
  INVALID_ORDER_STATE: 'INVALID_ORDER_STATE',
  ORDER_HAS_TO_HAVE_DELIVER_METHOD: 'ORDER_HAS_TO_HAVE_DELIVER_METHOD',
  BAD_REQUEST: 'BAD_REQUEST',
  DISCOUNT_CODE_EXPIRED: 'کد تخفیف منقضی شده است',
  USAGE_PER_USER_LIMIT: 'کد تخفیف استفاده شده است',
  DISCOUNT_CODE_NOT_FOUND: 'کد تخفیف یافت نشد!',
  SELECT_FROM_LOCATIONS: 'لطفا از مناطق تحت پوشش انتخاب نمایید',
  ORDER_SUBMIT_SUCCESS: 'سفارش با موفقیت ثبت گردید',
  ORDER_SUBMIT_REJECTED: 'خطا در انجام عملیات',
  OPERATION_SUBMIT_SUCCESS: 'عملیات با موفقیت انجام گردید.',
  DETAIL: 'جزئیات',

  NOT_ALLOW_REMOVE_ALL_ITEMS: 'امکان حذف تمام آیتم ها وجود ندارد',
  MIARE: 'میاره',
  SNAPP_BOX: 'اسنپ باکس',
  OWN_FLEET: 'پیک رستوران',

  [OrderState.CONFIRMED]: 'تایید شده',
  [OrderState.DELIVERED]: 'تحویل داده شده',
  [OrderState.DELIVERING]: 'در حال ارسال',
  [OrderState.FINISHED]: 'تمام شده',
  [OrderState.PAID]: 'پرداخت شده',
  [OrderState.READYTOSHIPMENT]: 'آماده ارسال',
  [OrderState.READYTOPICKUP]: 'آماده تحویل',
  [OrderState.READYTOSERVE]: 'آماده سرو',
  [OrderState.REJECTED]: 'رد شده',
  [OrderState.SUBMITTED]: 'در انتظار پرداخت',
  [OrderState.NEEDFORCALL]: 'در صف بررسی',
  [DeliveryType.DELIVER]: 'ارسال با پیک',
  [DeliveryType.PICKUP]: 'تحویل حضوری',
  [DeliveryType.SERVE]: 'سرو در محل',
  [DeliveryType.ZFEXPRESS]: 'اسنپ اکسپرس',
  [DiscountCodeType.FREEITEM]: 'آیتم رایگان',
  [DiscountCodeType.FREESHIPPING]: 'ارسال رایگان',
  [DiscountCodeType.MONEY]: 'تخفیف نقدی',
  [DiscountCodeType.PERCENTAGE]: 'تخفیف درصدی',

  [DeliveryState.REQUESTED]: 'ارسال درخواست پیک',
  [DeliveryState.ACCEPTED]: 'قبول شده توسط پیک',
  [DeliveryState.PICKED_UP]: 'در راه مشتری',

  [DeliveryState.CANCELED_BY_US]: 'لغو توسط اسنپ استور',
  [DeliveryState.ASSIGNED]: 'پیک در راه رستوران',
  [DeliveryState.ATRESTAURANT]: 'پیک در رستوران',
  [DeliveryState.CANCELED_BY_PROVIDER]: 'لغو توسط سرویس دهنده',
  [DeliveryState.TIMED_OUT]: 'منقضی شده',
  [DeliveryState.ACK]: 'تایید شده',

  [TransactionType.TOPUP]: 'افزایش موجودی',
  [TransactionType.REFUND]: 'بازگشت وجه',

  [TransactionStatus.PENDING]: 'ارسال به بانک',
  [TransactionStatus.DONE]: 'موفق',
  [TransactionStatus.FAILED]: 'ناموفق',
  [TransactionStatus.INIT]: 'اولیه',

  [OrderTypeEnums.KIOSK]: 'کیوسک',
  [OrderTypeEnums.WEBSITE]: 'سایت',
  [OrderTypeEnums.QR]: 'آنلاین',
  [OrderTypeEnums.SALON]: 'سالن',
  [OrderTypeEnums.SNAPPFOOD]: 'اسنپ فود',

  [PaymentMethod.CARD]: 'کارت',
  [PaymentMethod.CASH]: 'نقدی',
  [PaymentMethod.ONLINE]: 'آنلاین',
  [PaymentMethod.UNPAID]: 'پرداخت نشده',
  [PaymentMethod.FOODRO]: 'فودرو',

  printed: 'چاپ شده',
  notPrinted: 'چاپ نشده',

  MELLAT: 'ملت',
  MELLI: 'ملی',
  TEJARAT: 'تجارت',
  SAMAN: 'سامان',
  ASANPARDAKHT: 'آسان پرداخت',
  PARSIAN: 'پارسیان',
  ACTIVE: 'فعال',
  DE_ACTIVE: 'غیر فعال',
  ADD: 'افزودن',
  SAVE: 'ذخیره',
  UPDATE: 'ویرایش',
  DELETE: 'حذف',
  VANDAR: 'وندار',
  ZARIN_PAL: 'زرین پال',
  JIBIT: 'جیبیت',
  SNAPP_PAY_DIRECTDEBIT: 'SNAPP_PAY_DIRECTDEBIT',
  SNAPP_PAY_POSTPAID: 'SNAPP_PAY_POSTPAID',
  SNAPP_FOOD_WALLET: 'SNAPP_FOOD_WALLET',
  POS: 'POS',
};

export default messages;
